import React from "react";
import { ArrowRight, CalendarRange, ListChecks, FileText, Eye, ClipboardList, CalendarDays, Euro, Mail, Stethoscope, ScrollText } from "lucide-react";
import { pageOfScreen } from "../../navigation/navConfig";

const CARDS = {
  planning:    { title: 'Planning', kicker: 'Équipe', desc: "Le planning de l'équipe, semaine et mois, vos demi-journées.", screen: 'planning', icon: CalendarRange, hue: 'cyan' },
  taches:      { title: 'Tâches du jour', kicker: "Aujourd'hui", desc: 'Pointage, tâches du jour et « je vais être en retard ».', screen: 'taches', icon: ListChecks, hue: 'amber' },
  docs:        { title: 'Documents patients', kicker: 'Patients', desc: 'Informations patient et lecture des ordonnances.', screen: 'infos-patient', icon: FileText, hue: 'violet' },
  cv:          { title: 'Champ visuel', kicker: 'Patients', desc: 'Les champs visuels à réaliser et à transmettre au médecin.', screen: 'champ-visuel', icon: Eye, hue: 'rose' },
  preconsult:  { title: 'PréConsult', kicker: 'Patients', desc: 'Le recueil avant le passage du médecin.', screen: 'preconsult', icon: ClipboardList, hue: 'rose' },
  creneaux:    { title: 'Demande de créneaux', kicker: 'Équipe', desc: 'Demander vos jours de présence au cabinet.', screen: 'demandes-travail', icon: CalendarDays, hue: 'amber', badge: 'jours' },
  facturation: { title: 'Codification', kicker: 'Finances', desc: 'Nomenclature, cumuls, coefficients et codification des actes.', screen: 'facturation', icon: Euro, hue: 'emerald' },
  courrier:    { title: 'Courrier', kicker: 'Patients', desc: 'Votre corbeille de courrier, ouverte sur le bon onglet.', screen: 'a-traiter', ecran: 'COURRIER', icon: Mail, hue: 'rose', badge: 'a_traiter' },
  bloc:        { title: 'Bloc opératoire', kicker: 'Calendrier', desc: 'Le calendrier du bloc et les rendez-vous au centre.', screen: 'bloc-calendrier', icon: Stethoscope, hue: 'violet' },
  registre:    { title: 'Registre des factures', kicker: 'Finances', desc: 'Toutes les factures émises, ouvertes et réglées.', screen: 'registre', icon: ScrollText, hue: 'emerald' },
};
const STAFF = ['planning', 'taches', 'docs', 'preconsult'];
const DIR = ['planning', 'bloc', 'registre', 'courrier'];
const ROLE_CARDS = {
  'Secrétaire': ['planning', 'taches', 'docs', 'cv'],
  'Assistant': STAFF, 'Assistant(e)': STAFF, 'Orthoptiste': STAFF,
  'Médecin': ['planning', 'creneaux', 'facturation', 'courrier'],
  'Directeur': DIR, 'Manager': DIR,
};

const FuturCards = ({ tree, user, badges, onGoScreen }) => {
  const ids = (ROLE_CARDS[user?.role] || STAFF).filter(id => pageOfScreen(tree, CARDS[id].screen));
  return (
    <div className="opn-fxk" data-testid="fx-role-cards">
      {ids.map((id, i) => {
        const c = CARDS[id]; const I = c.icon; const n = badges?.[c.badge];
        return (
          <button key={id} type="button" className={`opn-fxk__card opn-fxk--${c.hue}`} style={{ animationDelay: `${i * 90}ms` }} onClick={() => onGoScreen(c.screen, c.ecran)} data-testid={`fx-card-${id}`}>
            <span className="opn-fxk__num">0{i + 1}</span>
            <span className="opn-fxk__scan" aria-hidden="true" />
            <span className="opn-fxk__orb" aria-hidden="true"><I className="opn-fxk__icon" /></span>
            <span className="opn-fxk__kicker">{c.kicker}{n > 0 && <span className="opn-fxk__n">{n}</span>}</span>
            <span className="opn-fxk__title">{c.title}</span>
            <span className="opn-fxk__desc">{c.desc}</span>
            <span className="opn-fxk__cta">Ouvrir <ArrowRight className="h-4 w-4" /></span>
          </button>
        );
      })}
    </div>
  );
};

export default FuturCards;
